import { connect } from 'react-redux';
import MobilePicker from '../components/mobile_picker';
import { fetchEvents, fetchRounds } from '../actions/leaderboardV2_index';
import { selectIsManagerSite } from '../selectors';

const mapStateToProps = (state) => {
  const isManagerSite = selectIsManagerSite(state);

  return {
    isManagerSite,
    // Managers stay in the round they are on; it is chosen elsewhere for them.
    showRoundsModal: state.leaderboardV2.roundList.length > 1 && !isManagerSite,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchEvents: (viewMode) => dispatch(fetchEvents(viewMode)),
  fetchRounds: () => dispatch(fetchRounds()),
});

// forwardRef: EventsList drives the sheet (open/close) through the ref.
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MobilePicker);
